export default {
    required: 'Zaznacz stan',
}